import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  EMPTY_STATE: `${cleanedFilename(__filename)}-empty-state`,
  OVERVIEW_HEADER: `${cleanedFilename(__filename)}-overview-header`,
};
